export const CEPService = {
  async searchForCepInViaCep(cep: string): Promise<Address | null> {
    try {
      const apiUrl = `https://viacep.com.br/ws/${cep}/json/`;

      const response = await fetch(apiUrl);

      if (!response.ok) {
        throw new Error('Erro ao buscar CEP');
      }

      const data: Address = await response.json();

      if (!data || data.erro) {
        throw new Error('CEP inválido');
      }

      return data;
    } catch (error) {
      console.error('Erro ao buscar CEP:', error);
      // Retorna null em caso de erro para permitir preenchimento manual
      return null;
    }
  },
};

export interface Address {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
  gia: string;
  ddd: string;
  siafi: string;
  erro?: boolean;
}
